import {
  PageLoaderContent,
  PageLoaderLogo,
  PageLoaderSpinner,
  PageLoaderWrapper,
} from './PageLoader.style'
import { Logo, Spinner } from './Icons'
import { useEffect, useRef, useState } from 'react'
import { useAdBlockStore, useRootStore } from '../../store'
import { usePageLoader } from '../../contexts'

export const PageLoader = () => {
  const { loading } = usePageLoader()
  const { isShowingMaavaron } = useRootStore()
  const [display, setDisplay] = useState<'none' | 'flex'>('flex')
  const pageLoaderTimeOut = useRef<null | NodeJS.Timeout>(null)

  // AdBlock Decision Engine result (RESH13-1075)
  const adDecision = useAdBlockStore(state => state.decision)

  useEffect(() => {
    const tdisplay =
      adDecision === 'block' || !loading || !isShowingMaavaron ? 'none' : 'flex'

    setTimeout(() => setDisplay(tdisplay), 200)
    pageLoaderTimeOut.current = setTimeout(() => setDisplay('none'), 18000)

    return () => {
      pageLoaderTimeOut.current && clearTimeout(pageLoaderTimeOut.current)
    }
  }, [adDecision, isShowingMaavaron, loading, setDisplay])

  return (
    <PageLoaderWrapper
      theme={{
        display: display,
      }}
    >
      <PageLoaderContent>
        <PageLoaderLogo>
          <Logo />
        </PageLoaderLogo>
        <PageLoaderSpinner>
          <Spinner />
        </PageLoaderSpinner>
      </PageLoaderContent>
    </PageLoaderWrapper>
  )
}
